"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdBannerType = exports.AdBannerVersion = exports.AdBannerSize = void 0;
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
var AdBannerSize;
(function (AdBannerSize) {
    AdBannerSize["MainContent"] = "main_content";
    AdBannerSize["MainIndex"] = "main_index";
    AdBannerSize["InText"] = "in_text";
    AdBannerSize["Medium"] = "medium";
    AdBannerSize["HorizontalMobile"] = "horizontal_mobile";
    AdBannerSize["Fullscreen"] = "fullscreen";
    AdBannerSize["Sticky"] = "sticky";
    AdBannerSize["StickyFixed"] = "sticky_fixed";
    AdBannerSize["StickyTeaser"] = "sticky_teaser";
})(AdBannerSize = exports.AdBannerSize || (exports.AdBannerSize = {}));
var AdBannerVersion;
(function (AdBannerVersion) {
    AdBannerVersion["GoogleAds"] = "GoogleAds";
    AdBannerVersion["WayToGrow"] = "WTG";
})(AdBannerVersion = exports.AdBannerVersion || (exports.AdBannerVersion = {}));
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
var AdBannerType;
(function (AdBannerType) {
    AdBannerType["Default"] = "default";
    AdBannerType["Sticky"] = "sticky";
    AdBannerType["StickyFixed"] = "sticky_fixed";
    AdBannerType["StickyTeaser"] = "sticky_teaser";
})(AdBannerType = exports.AdBannerType || (exports.AdBannerType = {}));
//# sourceMappingURL=AdBanner.contracts.js.map